import { Box } from '@mui/material';
import * as React from 'react';
import ChapterContentTable from './ChapterContentTable';

export default function ContentLayout() {
  return (
    <Box sx={{ mt: 2 }}>
      <ChapterContentTable />
    </Box>
  );
}
